import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import JewelryLogin from '../src/pages/Login';
import Layout from './components/Layout';
import BarcodeScanPopup from "../src/components/BarcodeScanPopup";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"          element={<JewelryLogin />} />
        <Route path="/dashboard" element={
          <>
            <BarcodeScanPopup />
            <Layout />
          </>
        } />
        <Route path="*"          element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;